import { render, staticRenderFns } from "./SuggestionTableItem.vue?vue&type=template&id=760e08e5&scoped=true"
import script from "./SuggestionTableItem.vue?vue&type=script&lang=js"
export * from "./SuggestionTableItem.vue?vue&type=script&lang=js"
import style0 from "./SuggestionTableItem.vue?vue&type=style&index=0&id=760e08e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760e08e5",
  null
  
)

export default component.exports